import Logger from "./Logger";

const __LOG__=[]

let __PAGE_LOG__=null

export default class LogController {
  static start({
                 group_name='',
                 group_key='',
                 group_val='',
                 remarks=''
               },log_id=""){
    let logger=new Logger()
    logger.start({
      group_name,
      group_key,
      group_val,
      remarks
    })
    if(!log_id){
      log_id=new Date().getTime()+"_"+Math.round(Math.random()*100)
    }
    __LOG__[log_id]=logger;
    return log_id;
  }

  static end(log_id,remarks=''){
    if(__LOG__[log_id]){
      try {
        __LOG__[log_id].end(remarks);
      }catch (e) {
        delete __LOG__[log_id];
      }
    }
  }

  static info(info,group_key="",group_val=""){
    if(typeof info !=="string"){
      info=JSON.stringify(info);
    }
    LogController.end(LogController.start({group_name:"info",group_key,group_val,remarks:info}));
  }
  static error(error,group_key="",group_val=""){
    if(typeof error !=="string"){
      error=JSON.stringify(error);
    }
    LogController.end(LogController.start({group_name:"error",group_key,group_val,remarks:error}));
  }
  static log(info,group_key="",group_val=""){
    if(typeof info !=="string"){
      info=JSON.stringify(info);
    }
    LogController.end(LogController.start({group_name:"log",group_key,group_val,remarks:info}));
  }

  static _onPage(){
    if(__PAGE_LOG__===null){
      __PAGE_LOG__=new Logger()
      __PAGE_LOG__.start({})
    }else {
      __PAGE_LOG__.end()
      __PAGE_LOG__=null;
      LogController._onPage()
    }
  }

  static onPage(router){
    router.afterEach((to, from) => {
      if(to.path!=='/login'&&to.path!=='/'){
          if(to.path!==from.path){
            LogController._onPage()
          }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/logger/LogController.js